import { Component, Input, OnInit } from '@angular/core';
import { StaticMaps } from '../../shared/models/static-maps';
import { ScreenUtils } from '../../utils/screen.utils';

@Component({
  selector: 'static-map',
  templateUrl: './static-map.component.html',
  styleUrls: ['./static-map.component.scss']
})
export class StaticMapComponent implements OnInit {

  @Input() staticMaps: StaticMaps;
  mapUrl: String;

  ngOnInit() {
    if (ScreenUtils.isMobileS()) {
      this.mapUrl = this.staticMaps.mobileS;
    }
    if (ScreenUtils.isMobileL()) {
      this.mapUrl = this.staticMaps.mobileL;
    }
    if (ScreenUtils.isTablet()) {
      this.mapUrl = this.staticMaps.tablet;
    }
    if (ScreenUtils.isDesktop()) {
      this.mapUrl = this.staticMaps.desktop;
    }
  }


}
